import {
  ErrorWithErrors,
  ErrorWithMessages,
  ErrorMessage,
  ErorrWithLocalizationError,
} from '../types/output-error.interface';

const hasKey = <K extends string>(obj: unknown, key: K): obj is { [P in K]: unknown } =>
  typeof obj === 'object' && obj !== null && Object.prototype.hasOwnProperty.call(obj, key);

const isErrorWithMessages = (error: unknown): error is ErrorWithMessages => {
  return (
    hasKey(error, 'error') &&
    hasKey(error.error, 'messages') &&
    Array.isArray(error['error']['messages']) &&
    error['error']['messages'].length > 0
  );
};

const isErrorMessage = (error: unknown): error is ErrorMessage => {
  return (
    hasKey(error, 'messages') && Array.isArray(error['messages']) && error['messages'].length > 0
  );
};

const isErrorWithErrors = (error: unknown): error is ErrorWithErrors => {
  return (
    hasKey(error, 'error') &&
    hasKey(error.error, 'errors') &&
    Array.isArray(error['error']['errors']) &&
    error['error']['errors'].length > 0 &&
    hasKey(error['error']['errors'][0], 'errorMessage')
  );
};

const isErrorWithLocalizationErrors = (error: unknown): error is ErorrWithLocalizationError => {
  return (
    hasKey(error, 'error') &&
    hasKey(error.error, 'localizationDetails') &&
    hasKey(error.error.localizationDetails, 'errorCode') &&
    typeof error.error.localizationDetails.errorCode === 'string' &&
    error.error.localizationDetails.errorCode.length > 0
  );
};

export const outputError = (error: unknown, defaultMessage: string): string => {
  if (isErrorWithMessages(error)) return error.error.messages.join(', ');
  if (isErrorWithErrors(error)) return error.error.errors[0].errorMessage;
  if (isErrorMessage(error)) return error.messages[0];
  if (error instanceof Error) return error.message ?? defaultMessage;
  if (typeof error === 'string') return error;

  return defaultMessage;
};

export const outputLocalizationError = (
  error: unknown,
  localizationPrefix: string,
  defaultMessage: string,
): string => {
  if (isErrorWithLocalizationErrors(error))
    return `${localizationPrefix}.${error.error.localizationDetails.errorCode}`;

  return defaultMessage;
};
